// IndexedDB schema for Tulsi offline data layer.
// One store per master (per-master TTL, cleaner queries), + outbox + _meta.
import { openDB } from "idb";

export const DB_NAME = "tulsi_offline";
export const DB_VERSION = 1;

export const MASTER_STORES = [
  "retailers",
  "distributors",
  "beats",
  "pjp",
  "products",
  "skus",
  "pricing",
  "schemes",
];

let _dbPromise = null;

export function getDB() {
  if (_dbPromise) return _dbPromise;
  _dbPromise = openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      for (const name of MASTER_STORES) {
        if (!db.objectStoreNames.contains(name)) {
          db.createObjectStore(name, { keyPath: "id" });
        }
      }
      if (!db.objectStoreNames.contains("_meta")) {
        db.createObjectStore("_meta", { keyPath: "key" });
      }
      if (!db.objectStoreNames.contains("outbox")) {
        const outbox = db.createObjectStore("outbox", { keyPath: "_id", autoIncrement: true });
        outbox.createIndex("by_status", "status");
        outbox.createIndex("by_key", "idempotency_key", { unique: true });
        outbox.createIndex("by_owner", "owner_user_id");
      }
      if (!db.objectStoreNames.contains("ping_history")) {
        // Local mirror of ping-log entries for the demo screen (read-through cache).
        db.createObjectStore("ping_history", { keyPath: "idempotency_key" });
      }
    },
  });
  return _dbPromise;
}

export async function metaGet(key) {
  const db = await getDB();
  return (await db.get("_meta", key))?.value;
}

export async function metaSet(key, value) {
  const db = await getDB();
  await db.put("_meta", { key, value });
}

export async function nukeAll() {
  const db = await getDB();
  const tx = db.transaction([...MASTER_STORES, "_meta", "outbox", "ping_history"], "readwrite");
  await Promise.all([
    ...MASTER_STORES.map((s) => tx.objectStore(s).clear()),
    tx.objectStore("_meta").clear(),
    tx.objectStore("outbox").clear(),
    tx.objectStore("ping_history").clear(),
  ]);
  await tx.done;
}
